import React, { ReactElement } from 'react';
import { Tab, TabGroup, TabGroupProps, TabList, TabPanel, TabPanels } from '@headlessui/react';
import classNames, { Argument } from 'classnames';

type TabType = {
  id?: string,
  title: string,
  component: ReactElement
};

type TabsProps = {
  tabs: Array<TabType>,
  className?: Argument,
  panelClassName?: string,
  tabBarClassName?: Argument,
  wrapperClassName?: Argument,
} & TabGroupProps;

const Tabs: React.FC<TabsProps> = ({
  tabs, selectedIndex, onChange, className, wrapperClassName: groupClassName, tabBarClassName, panelClassName, ...rest
}) => (
  <TabGroup selectedIndex={selectedIndex} onChange={onChange} className={classNames('w-full', groupClassName)} {...rest}>
    <TabList className={classNames('flex rounded-full bg-input-border p-3xs', tabBarClassName)}>
      {/* `component` prop should be ignored here */}
      {/* eslint-disable-next-line @typescript-eslint/no-unused-vars */}
      {tabs.map(({ id, title, component, ...rest }, index) => (
        <Tab
          key={id ?? index}
          className={classNames(
            'flex-1 rounded-full px-2xs py-2 [&[data-selected]]:bg-white [&[data-selected]]:shadow-sm text-xs font-bold',
            className
          )}
          {...rest}
        >
          {title}
        </Tab>
      ))}
    </TabList>
    <TabPanels className="my-l">
      {tabs.map(({ id, component }, index) => (
        <TabPanel key={id ?? index} className={panelClassName}>
          {component}
        </TabPanel>
      ))}
    </TabPanels>
  </TabGroup>
);

export default Tabs;